import { queryOptions } from '@tanstack/react-query';

import { osLotReviewsApi } from '../apis/os-lot-reviews';
import { OsLotReviewScopeParams } from '../os-lot-review-scope';

import { Filters, Globals, useQueriesWithGlobal } from '@data-access';

export const osLotReviewsQueries = (global: Globals) => ({
  all: () => [global, 'os-lot-reviews'],
  lists: () => [...osLotReviewsQueries(global).all(), 'list'],
  list: (filters: Filters) =>
    queryOptions({
      queryKey: [...osLotReviewsQueries(global).lists(), filters],
      queryFn: () => osLotReviewsApi.getAll(filters),
    }),
  summary: (columnFilters: Filters['filters']) =>
    queryOptions({
      queryKey: [...osLotReviewsQueries(global).all(), 'summary', columnFilters],
      queryFn: () => osLotReviewsApi.getSummary(columnFilters),
    }),
  details: () => [...osLotReviewsQueries(global).all(), 'detail'],
  detail: (lotId: number, scope: OsLotReviewScopeParams) =>
    queryOptions({
      queryKey: [...osLotReviewsQueries(global).details(), lotId, scope],
      queryFn: () => osLotReviewsApi.getDetail(lotId, scope),
    }),
});

export const useOsLotReviewsQueries = () => {
  return useQueriesWithGlobal(osLotReviewsQueries);
};
